import React from "react";
import "./HomeCollectionCss/HomeCollectionSuccessModal.css";
import { formatDobDisplay } from "../../utils/helper";

const HomeCollectionSuccessModal = ({ open, onClose, successDetails }) => {
  if (!open) return null;
  console.log("Success Details:", successDetails); // For debugging purposes

  return (
    <div className="success-backdrop">
      <div className="success-modal">
        {/* Header */}
        <div className="success-header">
          <h3>Home Collection Requested Successfully</h3>
          <button className="close-btn" onClick={onClose}>
            ×
          </button>
        </div>

        {/* Body */}
        {/* <div className="success-body">
          <p className="greeting">
            <strong>Hi {successDetails?.PFirstName || "Patient"} ,</strong>
          </p>

          <p className="message">
            Thank you for choosing RB Diagnostic. Your Home Collection request
            is awaiting confirmation.
          </p>

          <p className="details-title">Details below :</p>

          <div className="details-grid">
            <div className="label">Request Id</div>
            <div className="value">
              {successDetails?.appointment_id || "N/A"}
            </div>

            <div className="label">Date</div>
            <div className="value">
              {successDetails?.preferredDate || "N/A"}
            </div>

            <div className="label">Time</div>
            <div className="value">
              {`Your requested time is ${
                successDetails?.preferredTime || "N/A"
              }. The exact time will be
              messaged to you when home collection is scheduled.`}
            </div>

            <div className="label">Address</div>
            <div className="value">{successDetails?.address || "N/A"}</div>
          </div>
        </div> */}

        <p className="combined-details">
          Thank you for choosing <strong>RB Diagnostic</strong>. Your Home
          Collection request is awaiting confirmation. Your request ID is{" "}
          <strong>{successDetails?.appointment_id || "N/A"}</strong>. The
          requested appointment date is{" "}
          <strong>
            {successDetails?.preferredDate
              ? formatDobDisplay(successDetails?.preferredDate)
              : "N/A"}
          </strong>
          , and your preferred time is{" "}
          <strong>{successDetails?.preferredTime || "N/A"}</strong>. The exact
          time will be messaged to you once the home collection is scheduled.
          The collection address is{" "}
          <strong>{successDetails?.address || "N/A"}</strong>.
        </p>

        {/* Footer */}
        <div className="success-footer">
          <button className="ok-btn" onClick={onClose}>
            Ok
          </button>
        </div>
      </div>
    </div>
  );
};

export default HomeCollectionSuccessModal;
